import React from 'react';
import './PetVaccinationForm.scss';
import { VaccinationCard } from './VaccinationCard';
import { VaccinationData } from '..';

type Props = {
  petVaccination: VaccinationData;
};

export const PetVaccinationForm = ({ petVaccination }: Props) => {
  return (
    <div className="vaccination-list tab-content">
      <div className="list">
        <VaccinationCard
          title="Rabies vaccination"
          description="Vaccine act as an active immunising agent used to prevent infection caused by the rabies virus."
          data={{
            taken: petVaccination.rabies,
            takenDate: petVaccination.rabiesTaken,
            expiryDate: petVaccination.rabiesExpiry,
            type: 'rabies',
            fileDetails: petVaccination?.rabiesRecord,
          }}
        />
        <VaccinationCard
          title="DHLPP vaccination"
          description="Vaccine that includes viral diseases, hepatitis, parvovirus, parainfluenza and bacterial infection leptospirosis."
          data={{
            taken: petVaccination.dhlpp,
            takenDate: petVaccination.dhlppTaken,
            expiryDate: petVaccination.dhlppExpiry,
            type: 'dhlp',
            fileDetails: petVaccination?.dhlppRecord,
          }}
        />
        <VaccinationCard
          title="Bordetella Vaccination"
          description="A noncore vaccine usually given to dogs that are frequently exposed to other dogs in boarding or social settings."
          data={{
            taken: petVaccination.bordetella,
            takenDate: petVaccination.bordetellaTaken,
            expiryDate: petVaccination.bordetellaExpiry,
            type: 'bordetella',
            fileDetails: petVaccination?.bordetellaRecord,
          }}
        />
        <VaccinationCard
          title="Canine Vaccination"
          description="Vaccines help prepare a dog's immune system to defend itself from any invasion of disease-causing organisms."
          data={{
            taken: petVaccination.canine,
            takenDate: petVaccination.canineTaken,
            expiryDate: petVaccination.canineExpiry,
            type: 'canine',
            fileDetails: petVaccination?.canineRecord,
          }}
        />
      </div>
    </div>
  );
};
